export default function (state) {
    state.dateType =  1;
    state.dates =   [new Date().toStringRu(), new Date().toStringRu()];
    state.SumFrom =  0;
    state.SumTo =  0;
    state.AvailableSumFrom =  0;
    state.AvailableSumTo =  0;
    state.CurrencyIds =  [];
    state.ContragentId =  '';
    state.ContragentSearchTypeId =  '';
    state.Number =  '';
    state.Type =  '';
    state.OwnerLegalEntityId =  '';
    state.IsUsed =  false;
    state.IsPayed =  false;
    state.loading =  false;
}